import { RequestMethod } from './APICall';
export class Subscription {
    constructor(data = {}, api) {
        this.data = {};
        this.data = data;
        this.id = data.id;
        this.api = api;
    }
    /**
     *
     * @param stripe the stripe object to create the subscription with
     * @param cardToken token ID of tokenized card
     * @returns
     */
    async payWithStripe(stripe, cardToken) {
        const subscriptionData = {
            token: cardToken,
            email: this.data.email,
            first_name: this.data.first_name,
            last_name: this.data.last_name,
            street1: this.data.street1,
            mail_code: this.data.mail_code,
            city_id: this.data.city_id,
            subscription_plan_id: this.data.subscription_plan_id,
            portal_name: this.data.portal_name.trim().replace(/ /g, '_'),
            terms: this.data.terms,
            use_sca: 1,
            source: this.data.source,
            create_sample_data: this.data.create_sample_data,
            secure_site: 0,
            custom_domain: 'custom',
        };
        /*
        if (this.data.plan.addon) {
          subscriptionData.addon_domain = 1;
        } */
        const request = {
            requestMethod: RequestMethod.POST,
            endpoint: 'subscription',
            data: subscriptionData,
        };
        return new Promise((resolve, reject) => {
            this.api.send(request)
                .then((success) => {
                if (success.sca_status === 'requies_action' || success.sca_status === 'requires_source_action') {
                    stripe.confirmCardPayment(success.client_secret).then((pi) => {
                        if (pi.error) {
                            reject(pi.error);
                        }
                        else {
                            resolve(success);
                        }
                    }).catch((error) => {
                        reject(error);
                    });
                }
                else {
                    console.log('no auth, resolving');
                    resolve(success);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
//# sourceMappingURL=Subscription.js.map